"use strict";
/*
 * Copyright 2018 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawMessage = void 0;

var core_1 = require("../../core");

var MessageType_1 = require("./MessageType");
/**
 * The a raw message that doesn't assume any prefix.
 */


var RawMessage = /*#__PURE__*/function () {
  /**
   * @internal
   * @param buffer
   */
  function RawMessage(buffer) {
    _classCallCheck(this, RawMessage);

    this.buffer = buffer;
    this.type = MessageType_1.MessageType.RawMessage;
    this.payload = core_1.Convert.uint8ToHex(buffer);
  }
  /**
   * Create plain message object.
   * @returns PlainMessage
   */


  _createClass(RawMessage, [{
    key: "toBuffer",
    value: function toBuffer() {
      return this.buffer;
    }
  }, {
    key: "toDTO",
    value: function toDTO() {
      return this.payload;
    }
  }], [{
    key: "create",
    value: function create(buffer) {
      return new RawMessage(buffer);
    }
  }]);

  return RawMessage;
}();

exports.RawMessage = RawMessage;